var map = {
	"./weapon_s_1.png": "2d52",
	"./weapon_s_10.png": "8f9e",
	"./weapon_s_11.png": "1077",
	"./weapon_s_12.png": "ec17",
	"./weapon_s_13.png": "b42b",
	"./weapon_s_14.png": "5a8a",
	"./weapon_s_15.png": "69f1",
	"./weapon_s_16.png": "fea5",
	"./weapon_s_17.png": "7adc",
	"./weapon_s_18.png": "62b0",
	"./weapon_s_19.png": "daaf",
	"./weapon_s_2.png": "7340",
	"./weapon_s_20.png": "970a",
	"./weapon_s_21.png": "8ec4",
	"./weapon_s_26.png": "0664",
	"./weapon_s_3.png": "9f5a",
	"./weapon_s_4.png": "8850",
	"./weapon_s_5.png": "007a",
	"./weapon_s_6.png": "f586",
	"./weapon_s_7.png": "8d97",
	"./weapon_s_8.png": "9bcb",
	"./weapon_s_9.png": "f880"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bd8";